module.exports = __webpack_public_path__ + "static/media/Circle.a9f5737e.png";